/**
 * Formats a number with k/M suffixes.
 * @param {number|null|undefined} num
 * @param {string} [fallback="0"] - returned when num is null/undefined/NaN
 */
export const formatCount = (num, fallback = "0") => {
  if (num == null || num === "") return fallback;
  const n = Number(num);
  if (isNaN(n)) return fallback;
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1).replace(/\.0$/, "")}k`;
  return String(n);
};
